import { useEffect } from 'react'
import { Routes, Route, useLocation, useParams, Navigate } from 'react-router-dom'
import LeadFunnelPage from './pages/LeadFunnelPage'
import { scrollToJoinSection } from './lib/scroll-to-join'
import ThankYouPage from './pages/ThankYouPage'
import NewsletterPage from './pages/NewsletterPage'
import NewsletterPostPage from './pages/NewsletterPostPage'
import AIRoadmapPage from './pages/AIRoadmapPage'
import SEO from './components/SEO'
import B2BRoadmapPage from './pages/B2BRoadmapPage'
import Homepage from './pages/v2/Homepage'
import NotFoundPage from './pages/NotFoundPage'
import ForbiddenPage from './pages/ForbiddenPage'
import Resourcepage from './pages/v2/Resourcepage'
import AllResource from './pages/v2/AllResource'
import Newsletter from './pages/v2/Newsletter'
import BusinessPage from './pages/v2/Business'
import InviteAsSpeaker from './pages/v2/InviteAsSpeaker'
import DailyAIUpdates from './pages/v2/DailyAIUpdates'
import DailyAIUpdateDetailPage from './pages/v2/DailyAIUpdateDetailPage'
import IndiaJobMarketVisualizerPage from './pages/IndiaJobMarketVisualizerPage'
import YtV2Page from './pages/YtV2Page'
import MastermindPage from './pages/MastermindPage'

function LegacyNewsletterPostRedirect() {
  const { slug } = useParams<{ slug: string }>()
  const safe = slug?.trim() ?? ''
  if (!safe) return <Navigate to="/newsletter" replace />
  return <Navigate to={`/newsletter/${safe}`} replace />
}

function ScrollToJoinOnHash() {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    if (hash !== '#join') return
    const id = window.setTimeout(() => {
      scrollToJoinSection()
    }, 0)
    return () => window.clearTimeout(id)
  }, [pathname, hash])
  return null
}

/**
 * Reset scroll to top on every route change. React Router preserves the previous
 * page's scroll position by default — without this, clicking a footer link from
 * the bottom of one page drops the user into the middle/bottom of the next.
 * Skips when a hash is present (ScrollToHash / ScrollToJoinOnHash handle those).
 */
function ScrollToTopOnNavigate() {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    if (hash) return
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior })
  }, [pathname, hash])
  return null
}

/** Smooth-scroll to #id after navigation (incl. marketing CTAs). #join uses ScrollToJoinOnHash. */
function ScrollToHash() {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    if (!hash || hash === '#join') return
    const id = hash.slice(1)
    if (!id) return
    const t = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }, 0)
    return () => window.clearTimeout(t)
  }, [pathname, hash])
  return null
}

function App() {
  return (
    <>
      <SEO />
      <ScrollToTopOnNavigate />
      <ScrollToJoinOnHash />
      <ScrollToHash />
      <Routes>
        {/* <Route path="/" element={<LeadFunnelPage configKey="default" />} /> */}
        <Route path="/ig" element={<LeadFunnelPage configKey="default" />} />
        <Route path="/igip" element={<LeadFunnelPage configKey="default" />} />
        <Route path="/x" element={<LeadFunnelPage configKey="default" />} />
        <Route path="/linkedin" element={<LeadFunnelPage configKey="default" />} />
        <Route path="/yt" element={<LeadFunnelPage configKey="default" />} />
        <Route path="/community" element={<LeadFunnelPage configKey="community" />} />
        <Route path="/raj-perf" element={<LeadFunnelPage configKey="rajPerf" />} />
        <Route path="/faye" element={<LeadFunnelPage configKey="faye" />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route path="/nl" element={<NewsletterPage />} />
        <Route path="/nl/p/:slug" element={<LegacyNewsletterPostRedirect />} />
        <Route path="/image.png" element={<AIRoadmapPage />} />
        <Route path="/vk" element={<LeadFunnelPage configKey="vk" />} />
        <Route path="/codex" element={<LeadFunnelPage configKey="codex" />} />
        <Route path="/b2b" element={<B2BRoadmapPage />} />
        <Route path="/403" element={<ForbiddenPage/>} />
        <Route path="*" element={<NotFoundPage />} />

        {/* New Routes */}
        <Route path="/" element={<Homepage />} />
        <Route path="/resources" element={<Resourcepage />} />
        <Route path="/all-resources" element={<AllResource />} />
        <Route path="/newsletter/:slug" element={<NewsletterPostPage />} />
        <Route path="/newsletter" element={<Newsletter />} />
        <Route path="/business" element={<BusinessPage />} />
        <Route path="/invite-as-speaker" element={<InviteAsSpeaker />} />
        <Route path="/daily-ai-updates" element={<DailyAIUpdates />} />
        <Route path="/daily-ai-updates/:slug" element={<DailyAIUpdateDetailPage />} />
        <Route path="/india-job-market-visualizer" element={<IndiaJobMarketVisualizerPage />} />
        <Route path="/ig-v2" element={<YtV2Page />} />
        <Route path="/mastermind" element={<MastermindPage />} />
      </Routes>
    </>
  )
}

export default App
